export default {
  getTournamentsMembersData: ({ tournamentsMembersData }) => tournamentsMembersData,
  getCurrentRoundData: ({ currentRoundData }) => currentRoundData,
  getTournamentsMyRatingData: ({ tournamentsMyRatingData }) => tournamentsMyRatingData,
};